module.exports = __webpack_public_path__ + "static/app-shot-1-1-9497ee70579cf354a4d2cca728131572.jpg";